import React, { useState } from 'react';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';
import ChargesTab from './Charges/ChargesTab';
import ProfitLossTab from './Charges/ProfitLossTab';
import ExchangeRateTab from './Charges/ExchangeRateTab';

const ChargesTabs = () => {

return (
<>
    <div className="row-gap-2">
        <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
                <button className="nav-link active" id="Estimates-charges-tab" data-bs-toggle="pill"
                    data-bs-target="#Estimates-charges-tab-pane" type="button" role="tab"
                    aria-controls="Estimates-charges-tab-pane" aria-selected="true">
                    Entity
                </button>
            </li>

            {/* Disabled tab */}
            <li className="nav-item" role="presentation">
                <button className="nav-link disabled" id="Estimates-profit-loss-tab" data-bs-toggle="pill"
                    data-bs-target="#Estimates-profit-loss-tab-pane" type="button" role="tab"
                    aria-controls="Estimates-profit-loss-tab-pane" aria-selected="false" disabled>
                    Shipment
                </button>
            </li>

            <li className="nav-item" role="presentation">
                <button className="nav-link disabled" id="Estimates-exchange-rates-tab" data-bs-toggle="pill"
                    data-bs-target="#Estimates-exchange-rates-tab-pane" type="button" role="tab"
                    aria-controls="Estimates-exchange-rates-tab-pane" aria-selected="false" disabled>
                    Previous Declarations
                </button>
            </li>

            {/* New disabled tabs */}
            <li className="nav-item" role="presentation">
                <button className="nav-link disabled" id="Estimates-food-details-tab" type="button" role="tab"
                    aria-controls="Estimates-food-details-tab-pane" aria-selected="false" disabled>
                    Goods Details
                </button>
            </li>

            <li className="nav-item" role="presentation">
                <button className="nav-link disabled" id="Estimates-containers-tab" type="button" role="tab"
                    aria-controls="Estimates-containers-tab-pane" aria-selected="false" disabled>
                    Containers
                </button>
            </li>

            <li className="nav-item" role="presentation">
                <button className="nav-link disabled" id="Estimates-itinerary-tab" type="button" role="tab"
                    aria-controls="Estimates-itinerary-tab-pane" aria-selected="false" disabled>
                    Itinerary
                </button>
            </li>

            <li className="nav-item" role="presentation">
                <button className="nav-link disabled" id="Estimates-e-sanchit-tab" type="button" role="tab"
                    aria-controls="Estimates-e-sanchit-tab-pane" aria-selected="false" disabled>
                    Declarations E-Sanchit
                </button>
            </li>
        </ul>

        <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="Estimates-charges-tab-pane" role="tabpanel"
                aria-labelledby="Estimates-charges-tab" tabIndex="0">
                <ChargesTab />
            </div>
            <div className="tab-pane fade" id="Estimates-profit-loss-tab-pane" role="tabpanel"
                aria-labelledby="Estimates-profit-loss-tab" tabIndex="0">
                <ProfitLossTab />
            </div>
            <div className="tab-pane fade" id="Estimates-exchange-rates-tab-pane" role="tabpanel"
                aria-labelledby="Estimates-exchange-rates-tab" tabIndex="0">
                <ExchangeRateTab />
            </div>
        </div>

    </div>
    <div className="row justify-content-end mt-3 gap-2">
        <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
            Save
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
            Save & Close
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
            Save & New
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
            Close
        </button>

    </div>
</>
)
}

export default ChargesTabs;